import { Tabs, TabsProps } from "antd";
import { useMemo, useState } from "react";
import documentsTabElements from "@/common/const/elementsList/documentsTabElements";
import { MainHeader, ResetFiltersButton, SearchBar } from "@/components";
import DocumentsTabElement from "@/components/DocumentsList/DocumentsTabElement";
import { useTableContext } from "@/common/contexts/Table.context";
import useGetDocumentsMe from "@/common/api/queries/companyQueries/useGetDocumentsMe";
import DocumentsTable from "@/components/DocumentsList/DocumentsTable";
import CustomTabsRender from "@/components/Tabs/CustomTabsRender";
import UploadDocument from "@/components/DocumentsList/Actions/UploadDocument.button";
import {
  agreementTable,
  otherDocsTable,
  productsTable,
} from "@/common/strategies";

export default function DocumentsMe() {
  const [activeKey, setActiveKey] = useState(documentsTabElements[0].key);
  const { filters, currentPage, changePage, searchQ } = useTableContext();

  const { data } = useGetDocumentsMe(
    activeKey,
    currentPage * 10,
    filters,
    searchQ
  );

  const transformedData = useMemo(() => {
    return data ? { ...data, items: [...data.items] } : undefined;
  }, [data, currentPage]);

  const tabs = [
    {
      key: documentsTabElements[0].key,
      children: (
        <DocumentsTable
          items={transformedData?.items}
          strategy={agreementTable}
          total={data?.total}
        />
      ),
      label: (
        <DocumentsTabElement
          label={documentsTabElements[0].tabLabel}
          isActive={activeKey === documentsTabElements[0].key}
          tabIcon={documentsTabElements[0].tabIcon}
        />
      ),
    },
    {
      key: documentsTabElements[1].key,
      children: (
        <DocumentsTable
          items={transformedData?.items}
          strategy={productsTable}
          total={data?.total}
        />
      ),
      label: (
        <DocumentsTabElement
          label={documentsTabElements[1].tabLabel}
          isActive={activeKey === documentsTabElements[1].key}
          tabIcon={documentsTabElements[1].tabIcon}
        />
      ),
    },
    {
      key: documentsTabElements[2].key,
      children: (
        <DocumentsTable
          items={transformedData?.items}
          strategy={otherDocsTable}
          total={data?.total}
        />
      ),
      label: (
        <DocumentsTabElement
          label={documentsTabElements[2].tabLabel}
          isActive={activeKey === documentsTabElements[2].key}
          tabIcon={documentsTabElements[2].tabIcon}
        />
      ),
    },
  ];

  return (
    <>
      <MainHeader pageName="Documents">
        <SearchBar />
      </MainHeader>
      <Tabs
        items={tabs}
        onChange={(value) => {
          changePage(1);
          setActiveKey(value);
        }}
        className="px-5"
        renderTabBar={(props, DefaultTabBar) => {
          return CustomTabsRender(
            props as unknown as TabsProps["renderTabBar"],
            DefaultTabBar,
            <div className="w-full flex justify-between">
              <ResetFiltersButton />
              <UploadDocument />
            </div>
          );
        }}
      />
    </>
  );
}
